import React from 'react';
import styled from '@emotion/styled';
import { Button } from '@mui/material';

const SubmitFrame = styled.div({
    border: 'thin solid lightgray',
    borderRadius: '5px',
    padding: '1em',
    margin: '1em',
});

const SubmitPanel = styled.div({
    display: 'flex',
    justifyContent: 'center',
});

type SubmitButtonProps = {
    label: string;
    disabled: boolean;
    onClick?: () => void;
}

function SubmitButton(props: SubmitButtonProps) {
    return (
        <Button onClick={props.onClick} disabled={props.disabled}>{props.label}</Button>
    );
}

function SubmitCancel(props: { onClick?: () => void }) {
    const _props = {
        label: 'Cancel',
        disabled: false,
        ...props,
    };
    return (
        <SubmitButton {..._props} />
    );
}

function SubmitOK(props: { label?: string; disabled: boolean; onClick?: () => void }) {
    const _props = {
        label: props.label ?? 'OK',
        disabled: props.disabled,
        onClick: props.onClick,
    };
    return (
        <SubmitButton {..._props} />
    );
}

const FormContent = styled.div({
    padding: '1em',
});

export type SubmitFormProps = {
    modified: boolean;
    cancellable?:
    boolean; submitLabel?: string;
    onSubmit?: () => void;
    onCancel?: () => void;
}

export const SubmitForm = (props: React.PropsWithChildren<SubmitFormProps>) => {
    return (
        <SubmitFrame>
            <FormContent>
                {props.children}
            </FormContent>
            <SubmitPanel>
                {(props.cancellable ?? true) ? <SubmitCancel onClick={props.onCancel} /> : <React.Fragment />}
                <SubmitOK disabled={!props.modified} label={props.submitLabel} onClick={props.onSubmit} />
            </SubmitPanel>
        </SubmitFrame>
    );
};
